import { Component } from '@angular/core';
import { LoadingService } from '../../../core/services/loading/loading';

@Component({
  selector: 'app-loading',
  imports: [],
  templateUrl: './loading.html',
  styleUrl: './loading.css',
})
export class Loading {
    isLoading = false;
message = ''

  constructor(
    private loadingService: LoadingService,
  ) { }

  ngOnInit(): void {
    this.loadingService.isLoading$.subscribe(isLoading => this.isLoading = isLoading);
    this.loadingService.loadingMessage$.subscribe(message => this.message = message);
  }
}
